import {
  abandonedCheckout,
  addresses,
  brands,
  category,
  coupons,
  customers,
  giftcard,
  home,
  kitchens,
  meals,
  orders,
  promotions,
  riders,
  transactions,
  settlements,
  users,
  loyalty,
  deliveryRatesIcon,
  raas,
  feedModeration,
} from '../assets/svg';

export const navLinks = [
  {
    name: 'Dashboard',
    path: '/dashboard/',
    icon: home,
    restrictions: ['OPERATIONS', 'MARKETING', 'INITIATOR'],
  },
  {
    name: 'brand management',
    path: '/dashboard/brands',
    icon: brands,
    restrictions: ['INITIATOR'],
  },
  {
    name: 'kitchen management',
    path: '/dashboard/kitchens',
    icon: kitchens,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'category management',
    path: '/dashboard/categories',
    icon: category,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'orders management',
    path: '/dashboard/orders',
    icon: orders,
    restrictions: ['INITIATOR'],
  },
  {
    name: 'abandoned checkout',
    path: '/dashboard/abandoned-checkout',
    icon: abandonedCheckout,
    restrictions: ['INITIATOR'],
  },
  {
    name: 'flagged orders',
    path: '/dashboard/flagged-orders',
    icon: orders,
    restrictions: ['INITIATOR'],
  },
  // {
  //   name: 'meal management',
  //   path: '/dashboard/meals',
  //   icon: meals,
  //   restrictions: [],
  // },
  {
    name: 'food items',
    path: '/dashboard/food-items',
    icon: meals,
    restrictions: ['INITIATOR'],
  },
  // {
  //   name: 'variants management',
  //   path: '/dashboard/variants',
  //   icon: variants,
  //   restrictions: [],
  // },
  {
    name: 'users',
    path: '/dashboard/users',
    icon: users,
    restrictions: ['OPERATIONS'],
  },
  {
    name: 'customers',
    path: '/dashboard/customers',
    icon: customers,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'feed and review beta',
    path: '/dashboard/feed-reports',
    icon: feedModeration,
    restrictions: ['MARKETING', 'FINANCE', 'LOGISTICS', 'INITIATOR'],
  },
  {
    name: 'promotions management',
    path: '/dashboard/promotions',
    icon: promotions,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'Transactions',
    icon: transactions,
    restrictions: ['OPERATIONS'],
    isSubmenu: true,
    subMenuItems: [
      {
        name: 'transactions',
        path: '/dashboard/transactions',
        icon: transactions,
        restrictions: ['OPERATIONS', 'INITIATOR'],
      },
      {
        name: 'wallet transactions',
        path: '/dashboard/wallet-transactions',
        icon: transactions,
        restrictions: ['OPERATIONS'],
      },
      {
        name: 'refund configurations',
        path: '/dashboard/refund-configurations',
        icon: transactions,
        restrictions: ['OPERATIONS'],
      },
    ],
  },
  {
    name: 'Terminal reconciliation',
    path: '/dashboard/terminal-reconciliation',
    icon: transactions,
    restrictions: [],
  },
  {
    name: 'Settlements',
    path: '/dashboard/settlements',
    icon: settlements,
    restrictions: [],
  },
  {
    name: 'Payouts',
    path: '/dashboard/payouts',
    icon: settlements,
    restrictions: ['MARKETING', 'LOGISTICS', 'INITIATOR', 'COMMUNITY_MANAGER'],
    allowedRoles: ['OWNER', 'OPERATIONS', 'FINANCE'],
  },
  {
    name: 'delivery',
    icon: riders,
    restrictions: [],
    isSubmenu: true,
    subMenuItems: [
      {
        name: 'delivery riders',
        path: '/dashboard/pilots',
        icon: riders,
        restrictions: [],
      },
      {
        name: 'delivery rates',
        path: '/dashboard/delivery-rates',
        icon: deliveryRatesIcon,
        restrictions: [],
      },
      {
        name: 'kitchen configuration',
        path: '/dashboard/kitchen-configurations',
        icon: kitchens,
        restrictions: [],
      },
    ],
  },
  {
    name: 'addresses & locations',
    path: '/dashboard/addresses',
    icon: addresses,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'delivery area exclusions',
    path: '/dashboard/location/exclusions',
    icon: addresses,
    restrictions: ['OPERATIONS'],
  },
  {
    name: 'affiliate meal sharing',
    path: '/dashboard/affiliate-meals',
    icon: coupons,
    restrictions: [],
  },
  {
    name: 'coupons',
    path: '/dashboard/coupons',
    icon: coupons,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'gift cards',
    path: '/dashboard/gift-cards',
    icon: giftcard,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'loyalty program',
    path: '/dashboard/loyalty-program',
    icon: loyalty,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'Rider as a Service (RaaS)',
    path: '/dashboard/riders-as-service',
    icon: raas,
    // restrictions: ['OWNER', 'OPERATIONS', 'MARKETING', 'FINANCE', 'LOGISTICS', 'INITIATOR'],
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'email outreach',
    path: '/dashboard/outreach',
    icon: promotions,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'platform settings',
    path: '/dashboard/platform-settings',
    icon: kitchens,
    restrictions: [
      'OPERATIONS',
      'MARKETING',
      'FINANCE',
      'LOGISTICS',
      'INITIATOR',
    ],
  },
];

export const naira = '₦';
